<template>
  <div class="iframe-page-wrap" v-if="src">
    <div class="iframe-page_close" v-if="hasClose" @click="$emit('close')">x</div>
    <iframe :src="src"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    hasClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss">
.iframe-page-wrap {
  width: 100%;
  height: 100%;
  position: relative;

  .iframe-page_close {
    position: absolute;
    font-size: 25px;
    right: 18px;
    top: -1px;
    font-family: sans-serif;
    color: #79ffff;
    cursor: pointer;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
